import { useLocation } from 'react-router-dom';

export const useHeaderStyle = () => {
    const location = useLocation();
    return {
        backgroundColor: location.pathname === '/about' ? '#7A1777' : '#f8f8f8',
    };
};
